var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"className":"s-stroke","cx":"13","cy":"13.75","r":"12.2","stroke":"#507BA8","strokeWidth":"1.6","key":0}),React.createElement("path",{"className":"s-fill","d":"M19.7383 9.22765C19.5633 8.62858 19.1257 8.20067 18.5131 8.02951C16.6754 7.85835 14.8377 7.68718 13 7.77276C11.1623 7.77276 9.32458 7.85835 7.48686 8.02951C6.9618 8.20067 6.43674 8.71416 6.26172 9.22765C5.91276 11.8984 5.91276 14.6016 6.26172 17.2723C6.43674 17.8714 6.87429 18.2993 7.48686 18.4705C9.32458 18.6417 11.1623 18.8128 13 18.7272C14.8377 18.7272 16.6754 18.6417 18.5131 18.4705C19.1257 18.2993 19.5633 17.8714 19.7383 17.2723C20.0872 14.6016 20.0872 11.8984 19.7383 9.22765ZM11.2498 15.8175V10.6825L15.8003 13.25L11.2498 15.8175Z","fill":"#507BA8","key":1})]);
}

Icon.defaultProps = {"width":"26","height":"27","viewBox":"0 0 26 27","fill":"none"};

module.exports = Icon;

Icon.default = Icon;
